import { handleActions } from "redux-actions";
import actionCreators from "../../actions/top/services";

const initialState = {
  services: [],
  loading: true,
};

export default handleActions(
  {
    [actionCreators.top.services.set]: (state, action) =>
      Object.assign({}, state, action.payload),
    [actionCreators.top.services.success]: (state, action) =>
      Object.assign({}, state, action.payload.data, { loading: false }),
    [actionCreators.top.services.failure]: (state, action) =>
      Object.assign({}, state, {
        errorStatus: action.payload.error,
        loading: false,
      }),
  },
  initialState
);
